export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10310.c620329e.jpg";